import { ExternalLink, BookMarked } from "lucide-react";

// Shared "Sources" block: used under blog posts, Learn guides and comparison pages.
export const SourcesList = ({ sources = [], asOf, note, title = "Sources", testId = "sources" }) => {
  if (!sources.length && !note) return null;
  return (
    <section className="mt-10 rounded-2xl border border-border p-5" data-testid={testId}>
      <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-widest font-mono text-muted-foreground mb-2"><BookMarked className="h-3.5 w-3.5" /> {title}{asOf ? ` · as of ${asOf} · links verified monthly` : ""}</div>
      {sources.length > 0 && (
        <ol className="space-y-1.5 text-sm list-decimal pl-5">
          {sources.map((s) => (
            <li key={s.url}>
              <a href={s.url} target="_blank" rel="noopener noreferrer nofollow" className="text-primary hover:underline inline-flex items-center gap-1" data-testid="source-link">{s.title} <ExternalLink className="h-3 w-3" /></a>
              {s.publisher && <span className="text-muted-foreground"> · {s.publisher}</span>}
              {s.note && <span className="text-muted-foreground"> — {s.note}</span>}
            </li>
          ))}
        </ol>
      )}
      {note && <p className={`text-xs text-muted-foreground ${sources.length ? "mt-3" : ""}`} data-testid="sources-note">{note}</p>}
    </section>
  );
};

export const citationJsonLd = (sources = []) => sources.map((s) => ({ "@type": "CreativeWork", name: s.title, url: s.url, ...(s.publisher ? { publisher: { "@type": "Organization", name: s.publisher } } : {}) }));
